var _react_refresh_temp_1;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@lucidlink/uicore';
import { WorkspaceSettingsSidebar } from './components';
export const WorkspaceSettingsLayout = ({ children }) => (_jsxs(Box, { gap: "s", grow: 1, isFullWidth: true, kind: "level1", padding: "s", scrollableY: true, shrink: 1, children: [_jsx(WorkspaceSettingsSidebar, {}), _jsx(Box, { isFullWidth: true, orientation: "vertical", children: children })] }));
_react_refresh_temp_1 = WorkspaceSettingsLayout;
$RefreshReg$(_react_refresh_temp_1, "WorkspaceSettingsLayout");
